import { render, staticRenderFns } from "./TextInputV1Properties.vue?vue&type=template&id=73f34375&"
import script from "./TextInputV1Properties.vue?vue&type=script&lang=js&"
export * from "./TextInputV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports